import './assets/style.css';const modalCell = "_modalCell_uaesp_2";
const withoutBorder = "_withoutBorder_uaesp_9";
const label = "_label_uaesp_13";
const asterisk = "_asterisk_uaesp_25";
const criticalSection = "_criticalSection_uaesp_30";
const criticalIcon = "_criticalIcon_uaesp_47";
const clearButton = "_clearButton_uaesp_51";
const caption = "_caption_uaesp_55";
const suggestSection = "_suggestSection_uaesp_69";
const twinContainer = "_twinContainer_uaesp_75";
const textAreaContainer = "_textAreaContainer_uaesp_81";
const modalTextArea = "_modalTextArea_uaesp_88";
const criticalSectionMultiline = "_criticalSectionMultiline_uaesp_94";
const wordCount = "_wordCount_uaesp_112";
const s = {
  modalCell,
  withoutBorder,
  label,
  asterisk,
  criticalSection,
  criticalIcon,
  clearButton,
  caption,
  suggestSection,
  twinContainer,
  textAreaContainer,
  modalTextArea,
  criticalSectionMultiline,
  wordCount
};
export {
  s
};
